import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		type: "dark",
		primary: {
			light: "#333",
			main: "#333",
			// dark: will be calculated from palette.secondary.main,
			contrastText: "#fff",
		},
		secondary: {
			light: "#c10f3a",
			main: "#c10f3a",
			// dark: will be calculated from palette.secondary.main,
			contrastText: "#fff",
		},
		background: {
			default: "black",
		},
	},
	status: {
		danger: "blue",
	},
	typography: {
		fontFamily: '"SJ Sans", "Helvetica", "Arial", sans-serif',
		fontSize: 14,
		fontWeightLight: 300,
		fontWeightRegular: 400,
		fontWeightMedium: 500,
		h2: {
			fontWeight: "bold",
			letterSpacing: "-2px",
		},
		button: {
			fontWeight: "bold",
			textTransform: "none",
			light: "#333",
		},
	},
});

export default theme;
